// taken from http://jsfiddle.net/alansouzati/6L7tA/, customizings are very likely (update: yes, there are here:-) )
angular.module("common.services.anchorSmoothScroll", []).service('anchorSmoothScroll', function ($document, $window) {

    var document = $document[0];
    var window = $window;

    function getCurrentPagePosition(window, document) {
        // Firefox, Chrome, Opera, Safari
        if (window.pageYOffset) return window.pageYOffset;
        // Internet Explorer 6 - standards mode
        if (document.documentElement && document.documentElement.scrollTop)
            return document.documentElement.scrollTop;
        // Internet Explorer 6, 7 and 8
        if (document.body.scrollTop) return document.body.scrollTop;
        return 0;
    }

    function getElementY(document, element) {
        var y = element.offsetTop;
        var node = element;
        while (node.offsetParent && node.offsetParent != document.body) {
            node = node.offsetParent;
            y += node.offsetTop;
        }
        return y;
    }

    this.scrollDown = function (startY, stopY, speed, distance) {
        var timer = 0;

        var step = Math.round(distance / 25);
        var leapY = startY + step;

        for (var i = startY; i < stopY; i += step) {
            setTimeout("window.scrollTo(0, " + leapY + ")", timer * speed);
            leapY += step;
            if (leapY > stopY) leapY = stopY;
            timer++;
        }
    };

    this.scrollUp = function (startY, stopY, speed, distance) {
        var timer = 0;

        var step = Math.round(distance / 25);
        var leapY = startY - step;

        for (var i = startY; i > stopY; i -= step) {
            setTimeout("window.scrollTo(0, " + leapY + ")", timer * speed);
            leapY -= step;
            if (leapY < stopY) leapY = stopY;
            timer++;
        }
    };

    this.scrollToTop = function (stopY) {
        scrollTo(0, stopY);
    };

    this.scrollToElement = function (element, speed, shiftY, doNotScrollIfInViewport) {
        if (typeof doNotScrollIfInViewport != "undefined" &&
            doNotScrollIfInViewport &&
            this.elementIsInViewport(element)) {
            return; // do nothing
        }

        var startY = getCurrentPagePosition(window, document);
        var stopY = getElementY(document, element);
        if (typeof shiftY != "undefined") {
            stopY = stopY - shiftY;
        }

        var distance = stopY > startY ? stopY - startY : startY - stopY;

        if (distance < 100) {
            this.scrollToTop(stopY);

        } else {
            var defaultSpeed = Math.round(distance / 100);
            speed = speed || (defaultSpeed > 20 ? 20 : defaultSpeed);
            this.scrollUpOrDown(startY, stopY, speed, distance);
        }
    };

    this.scrollTo = function (elementId, speed) {
        // This scrolling function
        // is from http://www.itnewb.com/tutorial/Creating-the-Smooth-Scroll-Effect-with-JavaScript
        var element = document.getElementById(elementId);

        if (element) {
            this.scrollToElement(element, speed);
        }
    };

    this.scrollUpOrDown = function (startY, stopY, speed, distance) {
        if (stopY > startY) {
            this.scrollDown(startY, stopY, speed, distance);
        } else {
            this.scrollUp(startY, stopY, speed, distance);
        }
    };

    this.elementIsInViewport = function (element) {
        var bounding = element.getBoundingClientRect();
        return (
            bounding.top >= 0 &&
            bounding.left >= 0 &&
            bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
            bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
        );
    };

    this.scrollToFirstFormValidationError = function () {
        var context = this;
        setTimeout(function () {
            var elms = angular.element('.help-block-errors:not(.ng-hide)');
            if (elms.length) {
                context.scrollToElement(elms.get(0), 10, 100, true);
            }
        }, 100); // we have to wait till changes apply
    };


});